import React, { Component } from "react";

class FooterWidget extends Component {
  render() {
    return (
      <div className="widget">
        <h4 className="mb-3 mb-sm-5" style={{ color: "#00cf5d" }}>
          {this.props.Heading}
        </h4>
        {this.props.children}
      </div>
    );
  }
}

export default FooterWidget;
